export const incrementItemCart = (cart, item, nextQuantity) =>
    cart.map(object => {
        if (item.facialValue !== object.facialValue) return object;
        return {
            ...object,
            quantityQuery: nextQuantity || item.quantityQuery + object.quantityQuery
        };
    });

export const findCartItem = (item, cart) =>
    cart.find(({ facialValue }) => facialValue === item.facialValue);

export const filterCartItem = (item, cart) =>
    cart.filter(
        ({ quantityQuery, facialValue }) =>
            quantityQuery !== item.quantityQuery || facialValue !== item.facialValue
    );

export const doCartTotal = cart =>
    cart.reduce((acc, curr) => acc + curr.quantityQuery * curr.facialValue, 0);

export const findCartTotalQuantity = cart =>
    cart.reduce((acc, curr) => acc + curr.quantityQuery, 0);



// WEBPACK FOOTER //
// ./src/utils/cartUtils.js